import { render, staticRenderFns } from "./LogReferral.vue?vue&type=template&id=5a601496&"
import script from "./LogReferral.vue?vue&type=script&lang=js&"
export * from "./LogReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports